import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const LogoutIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };

  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 12H3.62"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const LogoutIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={LogoutIconSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default LogoutIcon;
